import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatMenuModule} from '@angular/material/menu';

import {ActionNotificationModule} from './components/action-natification/action-notification.module';
import {UploadImageModule} from './components/upload-image/upload-image.module';
import {ViewImageModule} from './components/view-image/view-image.module';
import {TextEditorModule} from './components/text-editor/text-editor.module';
import {BackButtonModule} from './components/back-button/back-button.module';

import {CheckScrollDirective} from './directive/check-scroll.directive';

import {EmbedVideoService} from './services/video.service';


import {StripHtmlPipe} from './pipe/strip-html.pipe';
import {ScrollToModule} from './components/scroll-to/scroll-to.module';
import {FabMenuModule} from './components/mat-fab-menu/fab-menu.module';
import {CustomSelectModule} from './components/custom-select/custom-select.module';
import {DateTimePickerModule} from './components/datetimepicker/date-time-picker.module';
import {IframeResizerDirective} from './directive/iframe-resizer.directive';
import {SafeUrlPipe} from './pipe/safe-url.pipe';
import {
    ConfirmationLeaveDialogComponent
} from './components/confirmation-leave-dialog/confirmation-leave-dialog.component';
import {HighlightDirective} from './directive/highlight.directive';
import {PhonePipe} from './pipe/phone.pipe';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        UploadImageModule,
        ViewImageModule,
        TextEditorModule,
        MatButtonToggleModule,
        MatMenuModule,
        BackButtonModule,
        ScrollToModule,
        FabMenuModule,
        CustomSelectModule,
        DateTimePickerModule
    ],
    declarations: [
        CheckScrollDirective,
        StripHtmlPipe,
        SafeUrlPipe,
        IframeResizerDirective,
        ConfirmationLeaveDialogComponent,
        HighlightDirective,
        PhonePipe
    ],
    providers: [
        EmbedVideoService,
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ActionNotificationModule,
        CheckScrollDirective,
        UploadImageModule,
        ViewImageModule,
        TextEditorModule,
        BackButtonModule,
        StripHtmlPipe,
        ScrollToModule,
        FabMenuModule,
        CustomSelectModule,
        DateTimePickerModule,
        IframeResizerDirective,
        SafeUrlPipe,
        HighlightDirective,
        PhonePipe
    ]
})
export class SharedModule {
}
